import { IsDefined, IsNumber, Length } from 'class-validator';
import { OrderFlightInfoBaseDto } from './order-flight-info-base.dto';

/**
 * Used to store information about orders and made at the airport POS.
 */
export class OrderFlightInfoForCreateDto extends OrderFlightInfoBaseDto {
  @IsDefined()
  @Length(3, 10)
  flightCode: string;

  @IsDefined()
  @Length(3)
  destinationCode: string;

  @IsDefined()
  @IsNumber()
  destinationZoneId: number;
}
